import {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {clearSelectedTimelineItem} from '../timeline-reducer';
import {TIMELINE_ITEM_DATA_ATTRIBUTE} from '../timeline.types';

/**
 * Hook that clears the selected timeline item when clicking outside of any timeline item.
 * Uses document-level event listener to detect clicks anywhere on the page.
 */
export function useClickOutsideToDeselect(): void {
  const dispatch = useAppDispatch();
  const selectedTimelineItem = useAppSelector((state) => state.timeline.selectedTimelineItem);

  useEffect(() => {
    if (!selectedTimelineItem) {
      return;
    }

    const handleDocumentClick = (e: MouseEvent): void => {
      if (!(e.target instanceof Element)) {
        dispatch(clearSelectedTimelineItem());
        return;
      }
      if (!e.target.closest(`[${TIMELINE_ITEM_DATA_ATTRIBUTE}]`)) {
        dispatch(clearSelectedTimelineItem());
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return (): void => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [selectedTimelineItem, dispatch]);
}
